module.exports = __webpack_public_path__ + "img/kidzone-card-orange-image.e06a7bc1.png";